// Grid import
import { Responsive, WidthProvider } from "react-grid-layout";

// Visuals imports
import {
    Container
  } from 'reactstrap';
import TurbHandler from '../components/handlers/Turb-handler';
import TableHandler from '../components/handlers/Table-handler';

//Global States
// import { useAtom } from "jotai";
// import { draggableAtom } from "../atoms/draggableAtom";

const ResponsiveGridLayout = WidthProvider(Responsive);

const layoutLg = [
  { i: "turb-summary", x: 0, y: 4, w: 6, h: 4, minH: 4, minW: 6  },
  { i: "table", x: 0, y: 0, w: 6, h: 4, minH: 4, minW: 6  }
];

const layoutMd = [
  { i: "turb-summary", x: 0, y: 4, w: 6, h: 4, minH: 4, minW: 6  },
  { i: "table", x: 0, y: 0, w: 6, h: 4, minH: 4, minW: 6  }
];

const layoutSm = [
  { i: "turb-summary", x: 0, y: 4, w: 4, h: 4, minH: 4, minW: 4 },
  { i: "table", x: 0, y: 0, w: 4, h: 4, minH: 4, minW: 4  }
];

const layoutXs = [
  { i: "turb-summary", x: 0, y: 4, w: 2, h: 4, minH: 4, minW: 2  },
  { i: "table", x: 0, y: 0, w: 2, h: 4, minH: 4, minW: 2 }
];

const getLayouts = () => {
  return { lg: layoutLg, md: layoutMd, sm: layoutSm, xs: layoutXs };
};


export const SummaryGrid = (props) => {

  const renderLoadingOrError = () => {
    if (props.isLoading) {
      return console.log('loading...')
    } else if (props.isError) {
      return console.log(props.errorMessage);
    }
    return null;
  };

  return (
    <>
      <Container>
        {renderLoadingOrError()}
        <ResponsiveGridLayout style={{zIndex:'0'}}
          layouts={getLayouts()}
          breakpoints={{ lg: 1920, md: 900, sm: 620, xs: 0 }}
          cols={{ lg: 6, md: 6, sm: 4, xs: 2 }}
          rowHeight={100}
          draggableCancel=".cancelSelectorName"
          isDraggable={false}
          isResizable={false}
        >
          <div key="turb-summary" style={{zIndex:'-1'}}>
            <TurbHandler className="cancelSelectorName" />
          </div>
          <div key="table" style={{zIndex:'-1'}}>
            <TableHandler className="cancelSelectorName"/>
          </div>
        </ResponsiveGridLayout>
      </Container>
    </>
  );
};